import {localeToHCLocale, Locale} from '../locale';
import {HttpUrl} from './types';

// in dev mode the `publicPath` should not be used. Vite will by default use `http://0.0.0.0:${PORT}`
export const ASSETS_URL_MOBILE_DEVELOPMENT = undefined;
export const ASSETS_URL_DESKTOP_DEVELOPMENT = undefined;

export const CHECKOUT_ASSETS_VERSION = 'frontend/checkout-wc/js';

export const KLARNA_SDK_URL_STAGING =
  '/postpurchaseexperience/lib/v1/playground/sdk.js';

export const KLARNA_SDK_URL_PRODUCTION =
  '/postpurchaseexperience/lib/v1/sdk.js';

export const ASSETS_URL_DESKTOP_PRODUCTION = 'https://assets.aboutstatic.com';
export const ASSETS_URL_MOBILE_PRODUCTION =
  process.env.NODE_ENV !== 'production' && process.env.HOSTNAME_OVERRIDE != null
    ? ASSETS_URL_MOBILE_DEVELOPMENT
    : 'https://m-assets.aboutstatic.com';
export const ASSETS_URL_DESKTOP_PREVIEW = undefined;
export const ASSETS_URL_MOBILE_PREVIEW =
  process.env.NODE_ENV !== 'production' && process.env.HOSTNAME_OVERRIDE != null
    ? ASSETS_URL_MOBILE_DEVELOPMENT
    : undefined;
export const ASSETS_URL_DESKTOP_STAGING = 'https://assets.aboutyou-staging.com';
export const ASSETS_URL_MOBILE_STAGING =
  process.env.NODE_ENV !== 'production' && process.env.HOSTNAME_OVERRIDE != null
    ? ASSETS_URL_MOBILE_DEVELOPMENT
    : 'https://m-assets.aboutyou-staging.com';

export const ASSETS_URL_MOBILE_FEATURE = undefined;
export const ASSETS_URL_DESKTOP_FEATURE = undefined;

/**
 * These are proxies port numbers for local development
 */
export enum PROXY_PORTS {
  IRIS_PORT = 8459,
  MAPI_PORT = 8460,
  BAPI_PORT = 8458,
  GRIPS_PORT = 8457,
  TADARIDA_PORT = 8456,
}

export const IRIS_URL_PRODUCTION = 'https://api.aboutyou.com';
export const IRIS_URL_STAGING = 'https://api.aboutyou-staging.com';
export const IRIS_URL_PREVIEW = 'https://api.aboutyou.com';
export const IRIS_URL_DEVELOPMENT = `http://${
  process.env.HOST as 'localhost'
}:${PROXY_PORTS.IRIS_PORT}` as const;

type LegacyDesktopEndpointBase =
  | typeof IRIS_URL_PRODUCTION
  | typeof IRIS_URL_STAGING
  | typeof IRIS_URL_PREVIEW
  | typeof IRIS_URL_DEVELOPMENT;

export const IRIS_URL_PRODUCTION_INTERNAL = 'https://api-internal.aboutyou.com';
export const IRIS_URL_STAGING_INTERNAL =
  'https://api-internal.aboutyou-staging.com';

export const MAPI_URL_STAGING_INTERNAL =
  'https://m-internal.aboutyou-staging.de/api';
export const MAPI_URL_PRODUCTION = 'https://m.aboutyou.de/api';
export const MAPI_URL_STAGING = 'https://m.aboutyou-staging.de/api';
export const MAPI_URL_PREVIEW = 'https://m.aboutyou.de/api';
export const MAPI_URL_DEVELOPMENT = `http://${
  process.env.HOST as 'localhost'
}:${PROXY_PORTS.MAPI_PORT}/api` as const;

type LegacyMobileEndpointBase =
  | typeof MAPI_URL_PRODUCTION
  | typeof MAPI_URL_STAGING
  | typeof MAPI_URL_STAGING_INTERNAL
  | typeof MAPI_URL_PREVIEW
  | typeof MAPI_URL_DEVELOPMENT;

export const getMobileWishlistEndpointPaths = (
  baseURL: LegacyMobileEndpointBase,
) => {
  return {
    BASE: `${baseURL}` as const,
    GET: `${baseURL}/wishlist/v7` as const,
    POST: `${baseURL}/wishlist/v7/items` as const,
    DELETE: `${baseURL}/wishlist/v7/items` as const,
  };
};

export const getDesktopWishlistEndpointPaths = (
  baseURL: LegacyDesktopEndpointBase,
) => {
  return {
    BASE: `${baseURL}/api` as const,
    GET: `${baseURL}/user/me/wishlist/bapi` as const,
    POST: `${baseURL}/user/me/wishlist/bapi` as const,
    DELETE: `${baseURL}/user/me/wishlist/bapi` as const,
  };
};

export const getDesktopHelpCenterEndpointByLocale = (
  baseURL: LegacyDesktopEndpointBase,
) =>
  Object.keys(localeToHCLocale).reduce(
    (memo, locale) => ({
      ...memo,
      [locale]: `${baseURL}/help-center/${
        localeToHCLocale[locale as Locale]
      }` as const,
    }),
    {} as Record<Locale, HttpUrl>,
  );

export const MEDIA_CDN_HOST = '//cdn.aboutstatic.com/file/';
